import { useCallback, useEffect, useState } from 'react';

/**
 * After a Continue or Create is refused, moves focus to the first invalid field
 * once the step has rendered and returns a message for the drawer's live
 * region. Call `attend` with a label that names the step.
 */
export function useStepAttention() {
  const [request, setRequest] = useState({ tick: 0, label: '' });
  const [announcement, setAnnouncement] = useState('');

  const attend = useCallback(
    (label: string) => setRequest((prev) => ({ tick: prev.tick + 1, label })),
    [],
  );

  useEffect(() => {
    if (request.tick === 0) return;
    const invalid = document.querySelectorAll<HTMLElement>(
      '.nb-cdrawer-content [aria-invalid="true"]',
    );
    invalid[0]?.focus();
    const count = invalid.length;
    setAnnouncement(
      `${request.label}: ${count} ${count === 1 ? 'field needs' : 'fields need'} attention.`,
    );
  }, [request]);

  return { attend, announcement };
}
